import { i18nKeys } from 'translationTypes'
import i18n from '../../../i18n'

export default {
  whyDoorDash: () => i18n.t(i18nKeys.dasherApplyPage__hamburger__title1),
  learnMore: () => i18n.t(i18nKeys.deliveryIssueShared_link_learn_more),
  signUpDetails: () => i18n.t(i18nKeys.dasherApplyPage__hamburger__title2),
  howToDash: () => i18n.t(i18nKeys.dasherApplyPage__hamburger__title3),
  faq: () => i18n.t(i18nKeys.dasherApplyPage__hamburger__title4),
}
